module.exports = __webpack_public_path__ + "media/good.98a28918.mp3";